export default {
  'menu.welcome': 'स्वागत है',
  'menu.entity': 'इकाई',
  'menu.more-blocks': 'और ब्लॉक',
  'menu.home': 'होम',
  'menu.admin': 'एडमिन',
  'menu.admin.sub-page': 'उप-पृष्ठ',
  'menu.login': 'लॉग इन',
  'menu.register': 'पंजीकरण',
  'menu.register-result': 'पंजीकरण परिणाम',
  'menu.dashboard': 'डैशबोर्ड',
  'menu.dashboard.analysis': 'ऐप्स',
  'menu.dashboard.monitor': 'मॉनिटर',
  'menu.flow': 'फ़्लो',
  'menu.divider': 'विभाजक',
  'menu.dashboard.workplace': 'कार्यस्थल',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'फ़ॉर्म',
  'menu.form.basic-form': 'बुनियादी फ़ॉर्म',
  'menu.form.step-form': 'चरणबद्ध फ़ॉर्म',
  'menu.form.step-form.info': 'चरणबद्ध फ़ॉर्म (स्थानांतरण जानकारी दर्ज करें)',
  'menu.form.step-form.confirm': 'चरणबद्ध फ़ॉर्म (स्थानांतरण जानकारी की पुष्टि करें)',
  'menu.form.step-form.result': 'चरणबद्ध फ़ॉर्म (पूर्ण)',
  'menu.form.advanced-form': 'उन्नत फ़ॉर्म',
  'menu.list': 'सूची',
  'menu.list.table-list': 'खोज तालिका',
  'menu.list.basic-list': 'बुनियादी सूची',
  'menu.list.card-list': 'कार्ड सूची',
  'menu.list.search-list': 'खोज सूची',
  'menu.list.search-list.articles': 'खोज सूची (लेख)',
  'menu.list.search-list.projects': 'खोज सूची (प्रोजेक्ट)',
  'menu.list.search-list.applications': 'खोज सूची (आवेदन)',
  'menu.profile': 'प्रोफ़ाइल',
  'menu.profile.basic': 'बुनियादी प्रोफ़ाइल',
  'menu.profile.advanced': 'उन्नत प्रोफ़ाइल',
  'menu.result': 'परिणाम',
  'menu.result.success': 'सफल',
  'menu.result.fail': 'विफल',
  'menu.exception': 'अपवाद',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'ट्रिगर',
  'menu.account': 'खाता',
  'menu.account.center': 'खाता केंद्र',
  'menu.account.settings': 'खाता सेटिंग्स',
  'menu.account.trigger': 'त्रुटि ट्रिगर करें',
  'menu.account.logout': 'लॉग आउट',
  'menu.editor': 'ग्राफ़िक संपादक',
  'menu.editor.flow': 'फ़्लो संपादक',
  'menu.editor.mind': 'माइंड संपादक',
  'menu.editor.koni': 'Koni संपादक',
  'menu.user-management': 'उपयोगकर्ता',
  'menu.tag-management': 'टैग',
  'menu.canned-response': 'पूर्वनिर्धारित',
  'menu.chatrooms': 'चैटरूम',
  'menu.email': 'ईमेल',
  'menu.core': 'मुख्य सुविधाएँ',
  'menu.files': 'फ़ाइलें',
  'menu.filesNew': 'फ़ाइलें (नया)',
  'menu.filesRefactored': 'फ़ाइलें (पुनर्संरचित)',
  'menu.favouritesHub': 'मैटर',
  'menu.library': 'प्रॉम्प्ट लाइब्रेरी',
  'menu.chat': 'चैट',
  'menu.search': 'खोज',
  'menu.specialised': 'विशेषीकृत',
  'menu.app': 'ऐप्स',
  'menu.playbook': 'वर्कस्टूडियो',
  'menu.template': 'कस्टम आउटपुट',
  'menu.quote': 'कोट',
  'menu.review': 'समीक्षा',
  'menu.sideBySide': 'साथ-साथ',
  'menu.grading': 'ग्रेडिंग',
  'menu.setting': 'सेटिंग्स',
  'menu.diagnostics': 'निदान',
  'menu.context': 'संदर्भ',
  'menu.management': 'प्रबंधन',
  'menu.conversation': 'बातचीत',
  'menu.translation': 'अनुवाद',
  'menu.broadcast': 'ब्रॉडकास्ट',
  'menu.dictionary': 'शब्दकोश',
  'menu.question': 'प्रश्न',
  'menu.nlp': 'NLP',
  'menu.form.new-flow': 'नया फ़्लो',
  'menu.form.update-flow': 'फ़्लो संशोधित करें',
  'menu.list.flow-list': 'फ़्लो सूची',
  'menu.comparison': 'तुलना',
  'menu.scribe': 'स्क्राइब',
  'menu.organisation': 'संगठन',
  'menu.superAdminOrganisation': 'सुपर एडमिन संगठन',
  'menu.section.vault': 'वॉल्ट',
  'menu.section.chatAndCompose': 'चैट और रचना',
  'menu.section.specialised': 'विशेषीकृत',
  'menu.section.system': 'सिस्टम',
};
